// extracted by mini-css-extract-plugin
module.exports = {"footerMain":"PublicFooter_footerMain__mA_Qa","wrapper":"PublicFooter_wrapper__LEFcH","footerChild":"PublicFooter_footerChild__euh6a"};